"use strict";
/*
 * --------------------------------------------------------------------------------------------------------------------
 * <copyright file="HxContactArgs.ts" company="Microsoft">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * <summary>
 *   !!! This is an automatically generated file for Actor Command Args and serialization helpers !!!
 *   Please run `MakeGenFiles.bat Actors` from the hxcomm/tools/bin
 *   directory to update its contents.
 * </summary>
 * Generating File: CommandArgsJs.tt
 * --------------------------------------------------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxContactArgs = void 0;
var HxContactAddressArgs_1 = require("./HxContactAddressArgs");
var HxContactEmailArgs_1 = require("./HxContactEmailArgs");
var HxContactImAddressArgs_1 = require("./HxContactImAddressArgs");
var HxContactDateArgs_1 = require("./HxContactDateArgs");
var HxContactPhoneArgs_1 = require("./HxContactPhoneArgs");
var HxContactSignificantOtherArgs_1 = require("./HxContactSignificantOtherArgs");
var HxContactUrlArgs_1 = require("./HxContactUrlArgs");
function serializeHxContactArgs(_arg) {
    var output = [];
    output.push(_arg.deviceId !== undefined);
    if (_arg.deviceId !== undefined) {
        output.push(_arg.deviceId);
    }
    output.push(_arg.hasRemoteId !== undefined);
    if (_arg.hasRemoteId !== undefined) {
        output.push(_arg.hasRemoteId);
    }
    output.push(_arg.addresses !== undefined);
    if (_arg.addresses !== undefined) {
        var addressesOutput_1 = [];
        _arg.addresses.forEach(function (item) { return addressesOutput_1.push(HxContactAddressArgs_1.serializeHxContactAddressArgs(item)); });
        output.push(addressesOutput_1);
    }
    output.push(_arg.age !== undefined);
    if (_arg.age !== undefined) {
        output.push(_arg.age);
    }
    output.push(_arg.assistantName !== undefined);
    if (_arg.assistantName !== undefined) {
        output.push(_arg.assistantName);
    }
    output.push(_arg.astrologySign !== undefined);
    if (_arg.astrologySign !== undefined) {
        output.push(_arg.astrologySign);
    }
    output.push(_arg.bloodType !== undefined);
    if (_arg.bloodType !== undefined) {
        output.push(_arg.bloodType);
    }
    output.push(_arg.businessHomePage !== undefined);
    if (_arg.businessHomePage !== undefined) {
        output.push(_arg.businessHomePage);
    }
    output.push(_arg.emails !== undefined);
    if (_arg.emails !== undefined) {
        var emailsOutput_1 = [];
        _arg.emails.forEach(function (item) { return emailsOutput_1.push(HxContactEmailArgs_1.serializeHxContactEmailArgs(item)); });
        output.push(emailsOutput_1);
    }
    output.push(_arg.displayName !== undefined);
    if (_arg.displayName !== undefined) {
        output.push(_arg.displayName);
    }
    output.push(_arg.displayNamePrefix !== undefined);
    if (_arg.displayNamePrefix !== undefined) {
        output.push(_arg.displayNamePrefix);
    }
    output.push(_arg.displayNameSuffix !== undefined);
    if (_arg.displayNameSuffix !== undefined) {
        output.push(_arg.displayNameSuffix);
    }
    output.push(_arg.categories !== undefined);
    if (_arg.categories !== undefined) {
        var categoriesOutput_1 = [];
        _arg.categories.forEach(function (item) { return categoriesOutput_1.push(item); });
        output.push(categoriesOutput_1);
    }
    output.push(_arg.imAddresses !== undefined);
    if (_arg.imAddresses !== undefined) {
        var imAddressesOutput_1 = [];
        _arg.imAddresses.forEach(function (item) { return imAddressesOutput_1.push(HxContactImAddressArgs_1.serializeHxContactImAddressArgs(item)); });
        output.push(imAddressesOutput_1);
    }
    output.push(_arg.importantDates !== undefined);
    if (_arg.importantDates !== undefined) {
        var importantDatesOutput_1 = [];
        _arg.importantDates.forEach(function (item) { return importantDatesOutput_1.push(HxContactDateArgs_1.serializeHxContactDateArgs(item)); });
        output.push(importantDatesOutput_1);
    }
    output.push(_arg.interests !== undefined);
    if (_arg.interests !== undefined) {
        output.push(_arg.interests);
    }
    output.push(_arg.isPrivate !== undefined);
    if (_arg.isPrivate !== undefined) {
        output.push(_arg.isPrivate);
    }
    output.push(_arg.jobInfoCompanyName !== undefined);
    if (_arg.jobInfoCompanyName !== undefined) {
        output.push(_arg.jobInfoCompanyName);
    }
    output.push(_arg.jobInfoCompanyYomiName !== undefined);
    if (_arg.jobInfoCompanyYomiName !== undefined) {
        output.push(_arg.jobInfoCompanyYomiName);
    }
    output.push(_arg.jobInfoDepartment !== undefined);
    if (_arg.jobInfoDepartment !== undefined) {
        output.push(_arg.jobInfoDepartment);
    }
    output.push(_arg.jobInfoManager !== undefined);
    if (_arg.jobInfoManager !== undefined) {
        output.push(_arg.jobInfoManager);
    }
    output.push(_arg.jobInfoOfficeLocation !== undefined);
    if (_arg.jobInfoOfficeLocation !== undefined) {
        output.push(_arg.jobInfoOfficeLocation);
    }
    output.push(_arg.jobInfoTitle !== undefined);
    if (_arg.jobInfoTitle !== undefined) {
        output.push(_arg.jobInfoTitle);
    }
    output.push(_arg.givenName !== undefined);
    if (_arg.givenName !== undefined) {
        output.push(_arg.givenName);
    }
    output.push(_arg.middleName !== undefined);
    if (_arg.middleName !== undefined) {
        output.push(_arg.middleName);
    }
    output.push(_arg.surname !== undefined);
    if (_arg.surname !== undefined) {
        output.push(_arg.surname);
    }
    output.push(_arg.nickname !== undefined);
    if (_arg.nickname !== undefined) {
        output.push(_arg.nickname);
    }
    output.push(_arg.notes !== undefined);
    if (_arg.notes !== undefined) {
        output.push(_arg.notes);
    }
    output.push(_arg.personalHomePage !== undefined);
    if (_arg.personalHomePage !== undefined) {
        output.push(_arg.personalHomePage);
    }
    output.push(_arg.phones !== undefined);
    if (_arg.phones !== undefined) {
        var phonesOutput_1 = [];
        _arg.phones.forEach(function (item) { return phonesOutput_1.push(HxContactPhoneArgs_1.serializeHxContactPhoneArgs(item)); });
        output.push(phonesOutput_1);
    }
    output.push(_arg.photo !== undefined);
    if (_arg.photo !== undefined) {
        output.push(_arg.photo);
    }
    output.push(_arg.significantOthers !== undefined);
    if (_arg.significantOthers !== undefined) {
        var significantOthersOutput_1 = [];
        _arg.significantOthers.forEach(function (item) { return significantOthersOutput_1.push(HxContactSignificantOtherArgs_1.serializeHxContactSignificantOtherArgs(item)); });
        output.push(significantOthersOutput_1);
    }
    output.push(_arg.urls !== undefined);
    if (_arg.urls !== undefined) {
        var urlsOutput_1 = [];
        _arg.urls.forEach(function (item) { return urlsOutput_1.push(HxContactUrlArgs_1.serializeHxContactUrlArgs(item)); });
        output.push(urlsOutput_1);
    }
    output.push(_arg.yomiGivenName !== undefined);
    if (_arg.yomiGivenName !== undefined) {
        output.push(_arg.yomiGivenName);
    }
    output.push(_arg.yomiNickname !== undefined);
    if (_arg.yomiNickname !== undefined) {
        output.push(_arg.yomiNickname);
    }
    output.push(_arg.yomiSurname !== undefined);
    if (_arg.yomiSurname !== undefined) {
        output.push(_arg.yomiSurname);
    }
    output.push(_arg.certificates !== undefined);
    if (_arg.certificates !== undefined) {
        var certificatesOutput_1 = [];
        _arg.certificates.forEach(function (item) { return certificatesOutput_1.push(item); });
        output.push(certificatesOutput_1);
    }
    return output;
}
exports.serializeHxContactArgs = serializeHxContactArgs;
